import { useTranslation } from 'react-i18next'

import { RadioButtonOptionCard } from '@reveni-io/reveni-ui'

import { exportTemplateOptions } from '../constants'
import * as Styles from './styles'

const ExportTemplateSelector = ({ value, onChange }) => {
  const { t } = useTranslation()

  return (
    <Styles.Options>
      {exportTemplateOptions.map(option => (
        <RadioButtonOptionCard
          key={option.value}
          icon={<option.Icon size={24} />}
          title={t(option.label)}
          description={t(option.description)}
          name="export-template"
          value={option.value}
          selected={value === option.value}
          onChange={onChange}
        />
      ))}
    </Styles.Options>
  )
}

export default ExportTemplateSelector
